var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebDevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 6.25H9.375C8.5462 6.25 7.75134 6.57924 7.16529 7.16529C6.57924 7.75134 6.25 8.5462 6.25 9.375V32.2917C6.25 33.1205 6.57924 33.9153 7.16529 34.5014C7.75134 35.0874 8.5462 35.4167 9.375 35.4167H40.625C41.4538 35.4167 42.2487 35.0874 42.8347 34.5014C43.4208 33.9153 43.75 33.1205 43.75 32.2917V21.875M25 35.4167V43.75",
    stroke: "#F2F2F2",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.875 6.25H9.375C8.5462 6.25 7.75134 6.57924 7.16529 7.16529C6.57924 7.75134 6.25 8.5462 6.25 9.375V32.2917C6.25 33.1205 6.57924 33.9153 7.16529 34.5014C7.75134 35.0874 8.5462 35.4167 9.375 35.4167H40.625C41.4538 35.4167 42.2487 35.0874 42.8347 34.5014C43.4208 33.9153 43.75 33.1205 43.75 32.2917V21.875M25 35.4167V43.75",
    stroke: "url(#pattern0)",
    strokeOpacity: 0.1,
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 6.25L29.1663 10.4167L33.333 14.5833M39.583 6.25L43.7497 10.4167L39.583 14.5833M14.583 43.75H35.4163",
    stroke: "#F2F2F2",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 6.25L29.1663 10.4167L33.333 14.5833M39.583 6.25L43.7497 10.4167L39.583 14.5833M14.583 43.75H35.4163",
    stroke: "url(#pattern1)",
    strokeOpacity: 0.1,
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevIcon);
export default __webpack_public_path__ + "static/media/WebDev-icon.96b1deb872b877135fcea784c5b48563.svg";
export { ForwardRef as ReactComponent };